import React from "react";
import {
  defineBlock,
  smartProps,
  EditableDiv,
  EditableImg,
} from "@smartfire/gutenberg-react";
import style from "./block.module.scss";

function Block() {
  return (
    <div className={style.block}>
      <EditableImg className={style.image} smartProp="image" />
      <EditableDiv className={style.spec} smartProp="spec" />
      <EditableDiv className={style.value} smartProp="value" />
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    image: smartProps.any.withDefault({}),
    spec: smartProps.string.withDefault("Volume"),
    value: smartProps.string.withDefault("xx ㎥"),
  },
  setup: {
    title: "Froid - Element Produit spec",
    parent: ["smartfire/froid-produit-description"],
  },
});
